import { range, add } from 'lodash';
import { MSDimension, MinsDimension } from '@utils/metrics/engagementMetrics';

// const SEGMENTATION_OF_500 = 200;

// key: diff of bucket -> for example: 0-1 -> the diff is 1 - 0 = 1.
// value is 2d array.
// [diff, number] for example, 0-1 -> the diff is 1. then value is [0.1, 10]
// the buckets are [0.1, 0.2], [0.2, 0.3] .... [0.9, 1]
export const diffBuckets = {
  0.2: [[0.02, 10]],
  1: [[0.1, 10]],
  5: [[1, 5]],
  10: [[1, 10]],
  20: [[5, 4]],
  40: [[5, 8]],
  50: [[5, 10]],
  500: [
    [50, 4],
    [100, 3],
  ],
  '>10': [
    [10, 1],
    [20, 4],
  ],
  '>60': [[20, 7]],
  '>240': [
    [10, 6],
    [50, 4],
  ],
  '>6000': [
    [100, 5],
    [500, 7],
    [10000, 2],
  ],
};

export const getBuckets = (bucketRange: string) => {
  bucketRange = bucketRange.replace(/\s/g, '');
  if (
    bucketRange === '>10' ||
    bucketRange === '>60' ||
    bucketRange === '>240' ||
    bucketRange === '>6000'
  ) {
    const bucketRule = diffBuckets[bucketRange];
    if (!bucketRule) {
      return [];
    }

    const value = parseInt(bucketRange.replace('>', ''), 10);
    return createBuckets(bucketRule, value);
  }

  const [rangeStart, rangeEnd] = bucketRange.split('-');
  const diff = parseFloat((parseFloat(rangeEnd) - parseFloat(rangeStart)).toPrecision(12));
  const bucketRule = diffBuckets[diff];
  if (!bucketRule) {
    return [];
  }

  return createBuckets(bucketRule, parseFloat(rangeStart));
};

export const getRangeBuckets = (bucketRange: string, dimension: string) => {
  const buckets = getBuckets(bucketRange);
  let diff = 1;
  if (MSDimension.includes(dimension)) {
    diff = 1000;
  } else if (MinsDimension.includes(dimension)) {
    diff = 1000 * 60;
  }
  return buckets.reduce((result, bucket) => {
    result[bucket] = bucket.split('-').reduce((range, value, index) => {
      const currentValue = parseFloat(value) * diff;
      if (index === 0) {
        return `[${currentValue},`;
      }
      return `${range}${currentValue})`;
    }, '');
    return result;
  }, {});
};

const createBucket = (value: number, diff: number, interval: number) =>
  range(interval).reduce((result: string[], x): string[] => {
    let currentValue = 0;
    let nextValue = 0;
    if (x === 0) {
      currentValue = value;
      nextValue = value + diff;
    } else {
      currentValue = add(value, x * diff);
      nextValue = add(value, (x + 1) * diff);
    }
    const fixedCount = diff === 0.1 ? 1 : 2;
    result.push(
      `${diff < 1 ? currentValue.toFixed(fixedCount) : currentValue}-${diff < 1 ? nextValue.toFixed(fixedCount) : nextValue}`,
    );
    return result;
  }, []);

const createBuckets = (bucketRule, value): string[] => {
  let total = value;

  return bucketRule.reduce((result, [diff, interval], index) => {
    if (index === 0) {
      result.push(...createBucket(total, diff, interval));
    } else {
      result.push(...createBucket(total, diff, interval));
    }
    total += diff * interval;
    return result;
  }, []);
};
